import { render, staticRenderFns } from "./LayoutConfigurationTitle.vue?vue&type=template&id=65d8b1fe&scoped=true&"
import script from "./LayoutConfigurationTitle.vue?vue&type=script&lang=js&"
export * from "./LayoutConfigurationTitle.vue?vue&type=script&lang=js&"
import style0 from "./LayoutConfigurationTitle.vue?vue&type=style&index=0&id=65d8b1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8b1fe",
  null
  
)

export default component.exports